<template>
    <div>
        <div class="com-model">
            <div class="com-model-title">
                <span>会员特权</span>
            </div>
            <div class="member-detail">
                <div class="member-detail-title flex m-b-14">
                    <img v-if="companyInfo.isVip" style="with: 34px;height: 34px;margin-right: 18px" src="../../assets/images/home/vip_icon.png">
                    <span>{{companyInfo.name}}</span>
                </div>
                <div class="flex " v-if="companyInfo.vipStart || companyInfo.vipEnd">
                    <template v-if="companyInfo.vipStart">
                        <div class="label">最近购买时间：</div>
                        <div class="time">{{companyInfo.vipStart.split(" ")[0]}}</div>
                    </template>
                    <template v-if="companyInfo.vipEnd">
                        <div class="label">会员到期时间：</div>
                        <div class="time">{{companyInfo.vipEnd.split(" ")[0]}}</div>
                    </template>
                    <router-link class="" :to="{path:'/index/finance'}" style="color: #057CF9">支付购买记录</router-link>
                </div>
            </div>
            <div class="vip-list-warper">
                <div class="tab-list flex m-b-24">
                    <div class="tab-item" :class="{
                        active: vipIndex == index
                    }" v-for="(item, index) in vipList" :key="item.id" @click="vipIndex = index">
                    <i class="el-icon-check"></i>
                        {{item.name}}
                    </div>
                </div>
                <div class="vip-content" v-if="currentVip">
                    <div class="vip-title">会员套餐包含内容</div>
                    <div class="content-list flex">
                        <div class="content-item">
                            <div class="icon">
                                <img src="../../assets/images/member/vip_icon_2.png">
                            </div>
                            <p>{{currentVip.collNum}}次简历免费加入次数</p>
                            <p>平台海量人才任你挑选</p>
                        </div>
                        <div class="content-item">
                            <div class="icon">
                                <img src="../../assets/images/member/vip_icon_1.png">
                            </div>
                            <p>最高{{currentVip.recruitNum}}个岗位发布上限</p>
                            <p>大量招聘需求轻松应对</p>
                        </div>
                        <div class="content-item">
                            <div class="icon">
                                <img src="../../assets/images/member/vip_icon_3.png">
                            </div>
                            <p>提高企业曝光率</p>
                            <p>专业一对一客户服务</p>
                        </div>
                    </div>
                </div>
                <div class="vip-long m-b-20" v-if="currentVip">
                    <p>当前公司：{{companyInfo.name}}</p>
                    <p>有效时长：{{currentVip.duration}}个月</p>
                    <p>充值方式：</p>
                </div>
                <div class="pay-type-list flex" style="margin-bottom: 20px">
                    <div @click="selPayway('alipay')" class="type-item flex flex-center" :class="{active:payType == 'alipay'}">
                        <img style="width: 44px; height:44px;margin-right: 16px" src="../../assets/images/zhifubao_icon.png" />
                        <i class="el-icon-check"></i>
                        支付宝
                    </div>
                    <div @click="selPayway('wxpay')"  class="type-item flex flex-center" :class="{active:payType == 'wxpay'}">
                        <img style="width: 44px; height:44px;margin-right: 16px" src="../../assets/images/weixin_icon.png" />
                        <i class="el-icon-check"></i>
                        微信
                    </div>
                </div>
                <div class="buys-money" v-if="currentVip">应付金额：<span>{{currentVip.price}}</span> 元</div>
                <div class="primary-btn" @click="buyVip" style="width: 250px">立即购买</div>
            </div>

        </div>
        <el-dialog
            title="扫码支付"
            :visible.sync="dialogVisible"
            v-if="currentVip"
            size="tiny"
            :before-close="handleClose">
            <div class="pay-qr flex flex-column flex-center">
                <img :src="base64Img" />
                <div class="pay-qr-text">
                    <p>请使用{{payType=='alipay' ? '支付宝':'微信'}}扫码支付</p>
                    <p>支付金额：<span>{{currentVip.price}}</span> 元</p>
                </div>
            </div>
        </el-dialog>
    </div>
</template>
<script>
const  qrcode=require('qrcode-js');
export default {
    data () {
        return {
            companyInfo: {},
            vipList: [],
            vipIndex: 0,
            payType: 'alipay',
            dialogVisible: false,
            base64Img: '',
            timer: null
        }
    },
    computed: {
        currentVip () {
            return this.vipList[this.vipIndex];
        }
    },
    mounted () {
        this.getVip();
        this.getInfo();
    },
    methods: {
        getVip () {
            let url = "/wapi/company/listVip";
            this.axios.get(url).then(res => {
                if (res.success) {
                    this.vipList = res.data;
                }
            });
        },
        getInfo () {
            let url = `/wapi/company/get`;
            this.axios.get(url).then(res => {
                this.companyInfo = res.data;
            });
        },
        selPayway (type) {
            this.payType = type;
        },
        buyVip () {
            // 默认支付宝
            const id = this.currentVip.id
            let url =  `/wapi/company/getBuyVipQR4AliCode?vipId=${id}`
            if (this.payType === 'wxpay') {
                url = `/wapi/company/getBuyVipQR4WXCode?vipId=${id}`;
            }
            this.axios.get(url).then(res => {
                if(res.success){
                    this.base64Img = qrcode.toDataURL(res.data.qrCode, 6);
                    this.dialogVisible = true;
                    this.queryPayOrder(res.data.sn)
                }
            });
        },
        // 判断是否支付成功
        queryPayOrder(sn){
            this.axios.get('/wapi/company/queryPayOrder?sn='+sn).then(res => {
                this.status = res.data.status;
                if (res.data.status == 1) {
                    // 支付成功
                    this.dialogVisible = false;
                    this.getInfo()
                } else {
                    this.timer = setTimeout(() => {
                        this.queryPayOrder(sn);
                    }, 1500);
                }
            })
        },
        handleClose () {
            this.dialogVisible = false;
            this.timer && clearTimeout(this.timer);
        }
    }
}
</script>
<style lang="less" scoped>
@import url('../../assets/less/base.less');
.com-model {
    border-radius: 10px;
}
.com-model-title{
    height: 66px;
    line-height: 66px;
    padding-left: 28px;
    border-bottom: 1px solid #ECECEC;
    margin-bottom: 33px;
    font-size: 20px;
    color: #000000;
}
.member-detail{
    padding-left: 25px;
    padding-bottom: 30px;
    border-bottom: 1px solid #ECECEC;
    margin-bottom: 25px;
    .member-detail-title{
        font-size: 20px;
        color: #262626;
    }
    .label{
        font-size: 16px;
        color: #999999;
    }
    .time{
        font-size: 16px;
        color: #262626;
        margin-right: 52px;
    }
}
.vip-list-warper{
    padding-left: 25px;
    padding-bottom: 35px;
    .tab-item{
        width: 150px;
        height: 44px;
        line-height: 44px;
        text-align: center;
        font-size: 16px;
        color: #333333;
        margin-right: 20px;
        cursor: pointer;
        border-radius: 2px;
        border: 1px solid #E6E6E6;
        .el-icon-check{
            display: none;
        }
        &.active{
            border: 1px solid #057CF9;
            position: relative;
            .el-icon-check{
                display: block;
                position: absolute;
                left: 0;
                top: 0;
                background: @color-primary;
                color: #fff;
                font-size: 10px;
                line-height: 16px;
                text-align: center;
                width: 16px;
                height: 16px;
                z-index: 100    ;
            }
        }
    }
}
.type-item{
    width: 225px;
    height: 70px;
    border-radius: 2px;
    border: 1px solid #E6E6E6;
    margin-right: 20px;
    // margin-bottom: 20px;
    font-size: 20px;
    color: #333333;
    cursor: pointer;
    .el-icon-check{
        display: none;
    }
    &.active{
        border: 1px solid #057CF9;
        position: relative;
        .el-icon-check{
            display: block;
            position: absolute;
            left: 0;
            top: 0;
            background: @color-primary;
            color: #fff;
            font-size: 10px;
            line-height: 16px;
            text-align: center;
            width: 16px;
            height: 16px;
            z-index: 100    ;
        }
    }
}
.vip-content{
    width: 725px;
    height: 266px;
    background: #FFFAF3;
    border-radius: 8px;
    box-sizing: border-box;
    padding: 12px 12px 50px;
    font-size: 16px;
    margin-bottom: 42px;
    .vip-title{
       color: #D0B692;
       margin-bottom: 25px;
    }
    .content-list{
        .content-item{
            width: 220px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            color: #9F6A56;
            line-height: 20px;
            .icon{
                width: 92px;
                height: 92px;
                margin-bottom: 24px;
                img{
                    width: 100%;
                    height: 100%;
                }
            }
        }
    }
}
.vip-long{
    font-size: 16px;
    color: #333333;
    line-height: 22px;
    margin-bottom: 10px;

}
.buys-money{
    font-size: 16px;
    color: #333333;
    margin-bottom: 60px;
    span{
        font-weight: 500;
        color: #FF7A45;
        line-height: 33px;
        font-size: 24px;
        margin: 0 8px;
    }
}
</style>



// WEBPACK FOOTER //
// info.vue?6d62935b